/**
 * @generated SignedSource<<fda8fd6df98646202060f0a2cec0bcb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LiveWidgetEditionEnum = "ASIA" | "HK" | "INT" | "US" | "%future added value";
export type homePageQuery$variables = {
  applicationId: string;
  chinaFutureTechSectionEntityId: string;
  chinaFutureTechStoryPackageArticlesQueueName: string;
  commentHarrySectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  commentQueueName: string;
  dailyPulseTypeUuId: string;
  focusQueueName: string;
  highlightQueueName: string;
  latestExcludeArticleTypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  latestExcludeSectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  liveWidgetEditionEnumValue: LiveWidgetEditionEnum;
  morningStudioQueueName: string;
  plusNewsAgendaEndDate: number;
  plusNewsAgendaStartDate: number;
  plusNewsAgendaTypes: ReadonlyArray<string | null | undefined>;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  secondaryStoryPackageArticlesQueueName: string;
  seriesWidgetArticlesQueueName: string;
  spotlightQueueName: string;
  storyPackageArticlesQueueName: string;
  topStoriesQueueName: string;
};
export type homePageQuery$data = {
  readonly commentQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly morningStudioQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"hooksPickMorningStudioArticle">;
  } | null | undefined;
  readonly secondaryStoryPackageArticles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly spotlightQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly storyPackageArticles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly topStories: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"heroArticleArticle">;
        };
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge" | "heroThreeArticlesQueueItemsEdge" | "topStoriesQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"chinaFutureTechStoryPackageQuery" | "chinaScienceDiscoveryWidgetQuery" | "commentQueueQuery" | "focusArticleHomeFocusArticleQuery" | "latestContentsQuery" | "plusWidgetQuery" | "secondaryStoryPackageQuery" | "seriesWidgetQuery" | "spotlightQuery" | "storyPackageQuery" | "superSplashQuery" | "thingsToDoQueue">;
};
export type homePageQuery = {
  response: homePageQuery$data;
  variables: homePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chinaFutureTechSectionEntityId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chinaFutureTechStoryPackageArticlesQueueName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentHarrySectionIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueName"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dailyPulseTypeUuId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "focusQueueName"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "highlightQueueName"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "latestExcludeArticleTypes"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "latestExcludeSectionIds"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "liveWidgetEditionEnumValue"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "morningStudioQueueName"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaEndDate"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaStartDate"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaTypes"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scmpPlusPaywallTypeIds"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "secondaryStoryPackageArticlesQueueName"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seriesWidgetArticlesQueueName"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spotlightQueueName"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storyPackageArticlesQueueName"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topStoriesQueueName"
},
v21 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "topStoriesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 18
  }
],
v23 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "topStoriesQueueItemsEdge"
},
v24 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge"
},
v25 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "morningStudioQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 9
  }
],
v27 = {
  "kind": "Variable",
  "name": "scmpPlusPaywallTypeIds",
  "variableName": "scmpPlusPaywallTypeIds"
},
v28 = [
  {
    "kind": "Variable",
    "name": "edition",
    "variableName": "liveWidgetEditionEnumValue"
  }
],
v29 = {
  "kind": "Variable",
  "name": "applicationId",
  "variableName": "applicationId"
},
v30 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "commentQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v31 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v32 = [
  (v31/*: any*/)
],
v33 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v24/*: any*/)
    ],
    "storageKey": null
  }
],
v34 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "storyPackageArticlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v35 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v36 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "spotlightQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v37 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v38 = [
  {
    "alias": null,
    "args": (v37/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v33/*: any*/),
    "storageKey": "items(first:4)"
  }
],
v39 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "secondaryStoryPackageArticlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v46 = [
  (v45/*: any*/)
],
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    (v44/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v46/*: any*/),
      "storageKey": null
    },
    (v47/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v50 = [
  (v49/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v51/*: any*/),
    (v52/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v50/*: any*/),
      "storageKey": null
    },
    (v47/*: any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v47/*: any*/)
  ],
  "storageKey": null
},
v57 = [
  (v41/*: any*/),
  (v47/*: any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "Section",
  "kind": "LinkedField",
  "name": "fullSectionPath",
  "plural": true,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    (v59/*: any*/),
    (v60/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v47/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v57/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v55/*: any*/),
    (v47/*: any*/)
  ],
  "storageKey": null
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v66/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    (v64/*: any*/),
    (v67/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/),
    (v55/*: any*/),
    (v56/*: any*/),
    (v58/*: any*/),
    (v61/*: any*/),
    (v65/*: any*/),
    (v68/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    (v48/*: any*/),
    (v47/*: any*/),
    (v53/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v54/*: any*/),
    (v69/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v77 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "1200x800"
    }
  }
],
v78 = {
  "alias": "size1200x800",
  "args": (v77/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v79 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v45/*: any*/),
    (v76/*: any*/),
    (v44/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/)
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v83 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/),
    (v41/*: any*/),
    (v55/*: any*/),
    (v42/*: any*/),
    (v56/*: any*/),
    (v58/*: any*/),
    (v61/*: any*/),
    (v65/*: any*/),
    (v68/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v43/*: any*/),
        (v47/*: any*/),
        (v53/*: any*/),
        (v83/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v86 = [
  (v85/*: any*/)
],
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v86/*: any*/),
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v85/*: any*/),
    (v49/*: any*/)
  ],
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v41/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v62/*: any*/),
    (v63/*: any*/),
    (v90/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v92 = {
  "kind": "InlineFragment",
  "selections": [
    (v90/*: any*/),
    (v67/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v93 = {
  "kind": "InlineFragment",
  "selections": [
    (v55/*: any*/),
    (v56/*: any*/),
    (v58/*: any*/),
    (v61/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "seriesContainer",
  "plural": false,
  "selections": [
    (v94/*: any*/),
    (v47/*: any*/),
    (v83/*: any*/)
  ],
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v86/*: any*/),
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v41/*: any*/),
        (v47/*: any*/),
        (v43/*: any*/),
        (v51/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v101/*: any*/),
    (v47/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v103 = {
  "kind": "InlineFragment",
  "selections": [
    (v90/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    (v66/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v94/*: any*/),
    (v95/*: any*/),
    (v96/*: any*/),
    (v97/*: any*/),
    (v98/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v102/*: any*/),
    (v53/*: any*/),
    (v103/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v106 = {
  "kind": "InlineFragment",
  "selections": [
    (v105/*: any*/),
    (v90/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/),
    (v72/*: any*/),
    (v73/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/),
    (v84/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/),
    (v89/*: any*/),
    (v93/*: any*/),
    (v104/*: any*/),
    (v106/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v108 = {
  "kind": "InlineFragment",
  "selections": [
    (v47/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v109 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v43/*: any*/),
        (v47/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    (v48/*: any*/),
    (v47/*: any*/)
  ],
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v43/*: any*/),
        (v41/*: any*/),
        (v51/*: any*/),
        (v47/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v112 = {
  "kind": "InlineFragment",
  "selections": [
    (v111/*: any*/),
    (v102/*: any*/),
    (v96/*: any*/),
    (v103/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v114 = [
  (v43/*: any*/),
  (v113/*: any*/)
],
v115 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/),
    (v41/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/)
      ],
      "type": "Section",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v114/*: any*/),
      "type": "Author",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v114/*: any*/),
      "type": "Topic",
      "abstractKey": null
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    (v48/*: any*/),
    (v47/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v54/*: any*/),
    (v53/*: any*/),
    (v69/*: any*/)
  ],
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v49/*: any*/),
    (v85/*: any*/)
  ],
  "storageKey": null
},
v118 = [
  (v64/*: any*/)
],
v119 = {
  "kind": "Variable",
  "name": "paywallTypeIds",
  "variableName": "scmpPlusPaywallTypeIds"
},
v120 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v121 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "PUBLISHED_DATE"
  }
},
v122 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isContent"
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v43/*: any*/),
        (v47/*: any*/),
        (v83/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settings",
  "storageKey": null
},
v125 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v126 = {
  "kind": "InlineFragment",
  "selections": [
    (v55/*: any*/),
    (v56/*: any*/),
    (v58/*: any*/),
    (v61/*: any*/),
    (v65/*: any*/),
    (v68/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v127 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "TERM_LOGO"
    }
  }
],
v128 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "style": "100x100"
        }
      }
    ],
    "concreteType": "ImageStyle",
    "kind": "LinkedField",
    "name": "style",
    "plural": false,
    "selections": (v46/*: any*/),
    "storageKey": "style(filter:{\"style\":\"100x100\"})"
  }
],
v129 = {
  "alias": "sectionLogo",
  "args": (v127/*: any*/),
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v128/*: any*/),
  "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
},
v130 = [
  (v113/*: any*/)
],
v131 = {
  "kind": "InlineFragment",
  "selections": (v130/*: any*/),
  "type": "Author",
  "abstractKey": null
},
v132 = {
  "kind": "InlineFragment",
  "selections": (v130/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v133 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/),
    (v55/*: any*/),
    (v42/*: any*/),
    (v56/*: any*/),
    (v58/*: any*/),
    (v61/*: any*/),
    (v65/*: any*/),
    (v68/*: any*/),
    (v131/*: any*/),
    (v132/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v134 = {
  "alias": null,
  "args": (v37/*: any*/),
  "concreteType": "QueueItemConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v40/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v41/*: any*/),
                (v42/*: any*/),
                (v116/*: any*/),
                (v71/*: any*/),
                (v72/*: any*/),
                (v73/*: any*/),
                (v74/*: any*/),
                (v75/*: any*/),
                (v80/*: any*/),
                (v81/*: any*/),
                (v82/*: any*/),
                (v84/*: any*/),
                (v117/*: any*/),
                (v87/*: any*/),
                (v89/*: any*/),
                (v93/*: any*/),
                (v104/*: any*/),
                (v106/*: any*/)
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            },
            (v108/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "items(first:4)"
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "refTerms",
  "plural": true,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latestArticleLink",
          "storageKey": null
        }
      ],
      "type": "Newsletter",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/),
        (v129/*: any*/),
        (v133/*: any*/)
      ],
      "type": "Section",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "TERM_LOGO"
            }
          ],
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v128/*: any*/),
          "storageKey": "image(type:\"TERM_LOGO\")"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v41/*: any*/),
            (v55/*: any*/),
            (v42/*: any*/),
            (v56/*: any*/),
            (v58/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v59/*: any*/),
                (v60/*: any*/),
                (v41/*: any*/)
              ],
              "type": "Section",
              "abstractKey": null
            },
            (v65/*: any*/),
            (v68/*: any*/),
            (v131/*: any*/),
            (v132/*: any*/)
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "type": "Topic",
      "abstractKey": null
    },
    (v108/*: any*/)
  ],
  "storageKey": null
},
v136 = {
  "alias": "landscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "homePageQuery",
    "selections": [
      {
        "alias": "topStories",
        "args": (v21/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "heroThreeArticlesQueueItemsEdge"
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "heroArticleArticle"
                      }
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:18)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "morningStudioQueue",
        "args": (v25/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hooksPickMorningStudioArticle",
            "selections": [
              {
                "alias": null,
                "args": (v26/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "aiArticleListSponsoredArticle"
                          }
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:9)"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "latestExcludeArticleTypes",
            "variableName": "latestExcludeArticleTypes"
          },
          {
            "kind": "Variable",
            "name": "latestExcludeSectionIds",
            "variableName": "latestExcludeSectionIds"
          },
          (v27/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "latestContentsQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "thingsToDoQueue"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "commentHarrySectionIds",
            "variableName": "commentHarrySectionIds"
          },
          {
            "kind": "Variable",
            "name": "commentQueueName",
            "variableName": "commentQueueName"
          },
          (v27/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "commentQueueQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "queueName",
            "variableName": "chinaFutureTechStoryPackageArticlesQueueName"
          },
          {
            "kind": "Variable",
            "name": "sectionEntityId",
            "variableName": "chinaFutureTechSectionEntityId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "chinaFutureTechStoryPackageQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "secondaryStoryPackageArticlesQueueName",
            "variableName": "secondaryStoryPackageArticlesQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "secondaryStoryPackageQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "storyPackageArticlesQueueName",
            "variableName": "storyPackageArticlesQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "storyPackageQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "seriesWidgetArticlesQueueName",
            "variableName": "seriesWidgetArticlesQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "seriesWidgetQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "spotlightQueueName",
            "variableName": "spotlightQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "spotlightQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "focusQueueName",
            "variableName": "focusQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "focusArticleHomeFocusArticleQuery"
      },
      {
        "args": (v28/*: any*/),
        "kind": "FragmentSpread",
        "name": "superSplashQuery"
      },
      {
        "args": [
          (v29/*: any*/),
          {
            "kind": "Variable",
            "name": "dailyPulseTypeUuId",
            "variableName": "dailyPulseTypeUuId"
          },
          {
            "kind": "Variable",
            "name": "highlightQueueName",
            "variableName": "highlightQueueName"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaEndDate",
            "variableName": "plusNewsAgendaEndDate"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaStartDate",
            "variableName": "plusNewsAgendaStartDate"
          },
          {
            "kind": "Variable",
            "name": "plusNewsAgendaTypes",
            "variableName": "plusNewsAgendaTypes"
          }
        ],
        "kind": "FragmentSpread",
        "name": "plusWidgetQuery"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "chinaScienceDiscoveryWidgetQuery"
      },
      {
        "alias": "commentQueue",
        "args": (v30/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v33/*: any*/),
            "storageKey": "items(first:5)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "storyPackageArticles",
        "args": (v34/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v33/*: any*/),
            "storageKey": "items(first:3)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "spotlightQueue",
        "args": (v36/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v38/*: any*/),
        "storageKey": null
      },
      {
        "alias": "secondaryStoryPackageArticles",
        "args": (v39/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v38/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v20/*: any*/)
    ],
    "kind": "Operation",
    "name": "homePageQuery",
    "selections": [
      {
        "alias": "topStories",
        "args": (v21/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Article",
                            "kind": "LinkedField",
                            "name": "moreOnThisArticles",
                            "plural": true,
                            "selections": [
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v47/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v75/*: any*/),
                                  (v81/*: any*/),
                                  (v40/*: any*/),
                                  (v82/*: any*/),
                                  (v109/*: any*/),
                                  (v110/*: any*/),
                                  (v112/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/),
                                  (v61/*: any*/),
                                  (v65/*: any*/),
                                  (v92/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v47/*: any*/),
                              (v115/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v58/*: any*/),
                              (v61/*: any*/),
                              (v65/*: any*/),
                              (v103/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:18)"
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "morningStudioQueue",
        "args": (v25/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v26/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v74/*: any*/),
                              (v75/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v84/*: any*/),
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              (v93/*: any*/),
                              (v104/*: any*/),
                              (v106/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v108/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v116/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v73/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/),
                          (v80/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v84/*: any*/),
                          (v117/*: any*/),
                          (v87/*: any*/),
                          (v89/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v58/*: any*/),
                              (v61/*: any*/),
                              (v65/*: any*/),
                              (v92/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v66/*: any*/),
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v94/*: any*/),
                              (v95/*: any*/),
                              (v96/*: any*/),
                              (v97/*: any*/),
                              (v98/*: any*/),
                              (v99/*: any*/),
                              (v100/*: any*/),
                              (v102/*: any*/),
                              (v53/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/),
                                  (v61/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v118/*: any*/),
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  (v103/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              },
                              (v103/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v106/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:9)"
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "articleTypeIds",
                "variableName": "latestExcludeArticleTypes"
              },
              (v119/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "articleExcludeInput"
          },
          {
            "kind": "Literal",
            "name": "articleFilterInput",
            "value": {
              "sponsorTypes": [
                "NONE"
              ]
            }
          },
          {
            "kind": "Literal",
            "name": "contentTypes",
            "value": [
              "ARTICLE",
              "GALLERY",
              "VIDEO"
            ]
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "sectionIds",
                "variableName": "latestExcludeSectionIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "exclude"
          },
          (v120/*: any*/),
          (v121/*: any*/)
        ],
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v122/*: any*/),
                  (v42/*: any*/),
                  (v71/*: any*/),
                  (v72/*: any*/),
                  (v73/*: any*/),
                  (v74/*: any*/),
                  (v75/*: any*/),
                  (v80/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v123/*: any*/),
                  (v110/*: any*/),
                  (v47/*: any*/),
                  (v93/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v97/*: any*/),
                      (v98/*: any*/),
                      (v99/*: any*/),
                      (v100/*: any*/),
                      (v102/*: any*/),
                      (v96/*: any*/),
                      (v103/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  (v106/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "thingToDoQueue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "homepage_service_journalism_hk"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v124/*: any*/),
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:3)"
          },
          (v47/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_service_journalism_hk\"})"
      },
      {
        "alias": "commentSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "93"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v42/*: any*/),
          (v47/*: any*/),
          (v115/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"93\"})"
      },
      {
        "alias": "commentQueue",
        "args": (v30/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v73/*: any*/),
                          (v74/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Author",
                            "kind": "LinkedField",
                            "name": "authors",
                            "plural": true,
                            "selections": [
                              (v41/*: any*/),
                              (v55/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "type": "AUTHOR_IMAGE"
                                    }
                                  }
                                ],
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                          "style": "300x300"
                                        }
                                      }
                                    ],
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v46/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"300x300\"})"
                                  }
                                ],
                                "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                              },
                              (v47/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/),
                                  (v42/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/),
                                  (v61/*: any*/),
                                  (v65/*: any*/),
                                  (v68/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          (v82/*: any*/),
                          (v75/*: any*/),
                          (v81/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/),
                          (v93/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v97/*: any*/),
                              (v98/*: any*/),
                              (v99/*: any*/),
                              (v100/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Author",
                                "kind": "LinkedField",
                                "name": "authors",
                                "plural": true,
                                "selections": [
                                  (v101/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v96/*: any*/),
                              (v103/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v105/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "type": "MAIN_IMAGE"
                                    }
                                  }
                                ],
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "alt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v77/*: any*/),
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v46/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                  }
                                ],
                                "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                              }
                            ],
                            "type": "Video",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "harryContents",
        "args": [
          {
            "fields": [
              (v119/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "articleExcludeInput"
          },
          {
            "kind": "Literal",
            "name": "contentTypes",
            "value": [
              "GALLERY"
            ]
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "sectionIds",
                "variableName": "commentHarrySectionIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v125/*: any*/),
          (v121/*: any*/)
        ],
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v40/*: any*/),
                  (v122/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v75/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v45/*: any*/),
                      (v76/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": "size660w",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "style": "660w"
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v46/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"660w\"})"
                      }
                    ],
                    "storageKey": null
                  },
                  (v110/*: any*/),
                  (v47/*: any*/),
                  (v126/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v96/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "chinaFutureTechSectionEntityId"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v43/*: any*/),
          (v129/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "subSections",
            "plural": false,
            "selections": [
              (v124/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v42/*: any*/)
                            ],
                            "type": "Topic",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v42/*: any*/),
                              (v56/*: any*/)
                            ],
                            "type": "Section",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v41/*: any*/),
                              (v55/*: any*/),
                              (v42/*: any*/),
                              (v56/*: any*/),
                              (v58/*: any*/),
                              (v61/*: any*/),
                              (v65/*: any*/),
                              (v68/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          },
                          (v108/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v47/*: any*/)
            ],
            "storageKey": null
          },
          (v40/*: any*/),
          (v47/*: any*/),
          (v133/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "chinaFutureTechStoryPackageArticles",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "chinaFutureTechStoryPackageArticlesQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v124/*: any*/),
          (v134/*: any*/),
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "secondaryStoryPackageArticles",
        "args": (v39/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v135/*: any*/),
          (v124/*: any*/),
          (v134/*: any*/),
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "storyPackageArticles",
        "args": (v34/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v135/*: any*/),
          (v124/*: any*/),
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v73/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v45/*: any*/),
                              (v76/*: any*/),
                              (v44/*: any*/),
                              (v136/*: any*/),
                              (v79/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/),
                          (v52/*: any*/),
                          (v93/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v97/*: any*/),
                              (v98/*: any*/),
                              (v99/*: any*/),
                              (v100/*: any*/),
                              (v102/*: any*/),
                              (v96/*: any*/),
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v103/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v106/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:3)"
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "seriesWidgetArticles",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "seriesWidgetArticlesQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v94/*: any*/),
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "series",
                            "plural": true,
                            "selections": [
                              (v40/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v73/*: any*/),
                                  (v75/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v45/*: any*/),
                                      (v76/*: any*/),
                                      (v44/*: any*/),
                                      (v136/*: any*/),
                                      (v79/*: any*/),
                                      (v78/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v70/*: any*/),
                                  (v71/*: any*/),
                                  (v72/*: any*/),
                                  (v74/*: any*/),
                                  (v81/*: any*/),
                                  (v82/*: any*/),
                                  (v84/*: any*/),
                                  (v87/*: any*/),
                                  (v88/*: any*/),
                                  (v89/*: any*/),
                                  (v93/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v66/*: any*/),
                                      (v62/*: any*/),
                                      (v63/*: any*/),
                                      (v96/*: any*/),
                                      (v97/*: any*/),
                                      (v98/*: any*/),
                                      (v99/*: any*/),
                                      (v100/*: any*/),
                                      (v102/*: any*/),
                                      (v53/*: any*/),
                                      (v94/*: any*/),
                                      (v95/*: any*/),
                                      (v103/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  (v106/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v108/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v126/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "spotlightQueue",
        "args": (v36/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v134/*: any*/),
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "focus",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "focusQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          (v124/*: any*/),
          {
            "alias": null,
            "args": [
              (v125/*: any*/)
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v75/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v45/*: any*/),
                              (v76/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": "size1280x720",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v46/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                              },
                              {
                                "alias": "size640x360",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape_640_360"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v46/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape_640_360\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/),
                          (v42/*: any*/),
                          (v93/*: any*/),
                          (v106/*: any*/),
                          (v112/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleTypeSegment",
                            "kind": "LinkedField",
                            "name": "types",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleType",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": (v57/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegment",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v41/*: any*/),
                                  (v47/*: any*/),
                                  (v43/*: any*/),
                                  (v42/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v127/*: any*/),
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "image",
                                    "plural": false,
                                    "selections": (v128/*: any*/),
                                    "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v62/*: any*/),
                          (v63/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v118/*: any*/),
                        "type": "Video",
                        "abstractKey": null
                      },
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:1)"
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": (v28/*: any*/),
            "kind": "ObjectValue",
            "name": "filter"
          },
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
              "direction": "DESC",
              "field": "UPDATED_DATE"
            }
          }
        ],
        "concreteType": "LiveWidget",
        "kind": "LinkedField",
        "name": "liveWidget",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "style",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "relatedArticles",
            "plural": true,
            "selections": [
              (v55/*: any*/),
              (v42/*: any*/),
              (v47/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v41/*: any*/),
                  (v71/*: any*/),
                  (v72/*: any*/),
                  (v73/*: any*/),
                  (v74/*: any*/),
                  (v40/*: any*/),
                  (v75/*: any*/),
                  (v80/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegment",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Section",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v43/*: any*/),
                          (v47/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      (v48/*: any*/),
                      (v47/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v87/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": (v86/*: any*/),
                    "storageKey": null
                  },
                  (v89/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v56/*: any*/),
                      (v58/*: any*/),
                      (v61/*: any*/),
                      (v91/*: any*/),
                      (v92/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v97/*: any*/),
                      (v98/*: any*/),
                      (v99/*: any*/),
                      (v100/*: any*/),
                      (v102/*: any*/),
                      (v96/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      (v53/*: any*/),
                      (v103/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  }
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          (v47/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "dailyPulseQuery",
        "args": [
          {
            "fields": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "typeIds.0",
                    "variableName": "dailyPulseTypeUuId"
                  }
                ],
                "kind": "ListValue",
                "name": "typeIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v125/*: any*/),
          (v121/*: any*/)
        ],
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Article",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v47/*: any*/),
                  (v69/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v75/*: any*/),
                      (v81/*: any*/),
                      (v40/*: any*/),
                      (v82/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegment",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v43/*: any*/),
                              (v47/*: any*/),
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v110/*: any*/),
                      (v71/*: any*/),
                      (v73/*: any*/),
                      (v72/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v111/*: any*/),
                          (v102/*: any*/),
                          (v96/*: any*/),
                          (v66/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "highlightQueue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "highlightQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 2
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v75/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v45/*: any*/),
                              (v76/*: any*/),
                              (v44/*: any*/),
                              (v79/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v123/*: any*/),
                          (v110/*: any*/),
                          (v93/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v66/*: any*/),
                              (v99/*: any*/),
                              (v102/*: any*/),
                              (v96/*: any*/),
                              (v103/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:2)"
          },
          (v47/*: any*/),
          (v124/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v29/*: any*/),
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "endDate",
                    "variableName": "plusNewsAgendaEndDate"
                  },
                  {
                    "kind": "Variable",
                    "name": "startDate",
                    "variableName": "plusNewsAgendaStartDate"
                  }
                ],
                "kind": "ObjectValue",
                "name": "newsAgendaDateRange"
              },
              {
                "kind": "Literal",
                "name": "newsAgendaOptions",
                "value": [
                  "key_event"
                ]
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "plusNewsAgendaTypes"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          },
          (v31/*: any*/),
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
              "direction": "ASC",
              "field": "NEWS_AGENDA_START_DATE"
            }
          }
        ],
        "concreteType": "TopicConnection",
        "kind": "LinkedField",
        "name": "topics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewsAgenda",
                    "kind": "LinkedField",
                    "name": "newsAgenda",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "secondaryDescription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "time",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newsAgendaOptions",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v41/*: any*/),
                  (v43/*: any*/),
                  (v51/*: any*/),
                  (v72/*: any*/),
                  (v47/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "scmp_pwa_settings"
            }
          }
        ],
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v85/*: any*/),
          (v47/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
      },
      {
        "alias": "chinaScienceSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "328475"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v42/*: any*/),
          (v43/*: any*/),
          (v41/*: any*/),
          (v60/*: any*/),
          (v47/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"328475\"})"
      },
      {
        "alias": "chinaScienceQueue",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "section_top_328475"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v120/*: any*/)
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v41/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v74/*: any*/),
                              (v75/*: any*/),
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v84/*: any*/),
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              (v93/*: any*/),
                              (v104/*: any*/),
                              (v106/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v108/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:6)"
          },
          (v47/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"section_top_328475\"})"
      }
    ]
  },
  "params": {
    "cacheID": "b70f4a44a20e49f35d16595a69777af0",
    "id": null,
    "metadata": {},
    "name": "homePageQuery",
    "operationKind": "query",
    "text": "query homePageQuery(\n  $applicationId: String!\n  $chinaFutureTechSectionEntityId: String!\n  $chinaFutureTechStoryPackageArticlesQueueName: String!\n  $commentHarrySectionIds: [String]\n  $commentQueueName: String!\n  $dailyPulseTypeUuId: String!\n  $focusQueueName: String!\n  $highlightQueueName: String!\n  $latestExcludeArticleTypes: [String]\n  $latestExcludeSectionIds: [String]\n  $liveWidgetEditionEnumValue: LiveWidgetEditionEnum!\n  $morningStudioQueueName: String!\n  $plusNewsAgendaEndDate: Timestamp!\n  $plusNewsAgendaStartDate: Timestamp!\n  $plusNewsAgendaTypes: [String]!\n  $scmpPlusPaywallTypeIds: [String]\n  $spotlightQueueName: String!\n  $storyPackageArticlesQueueName: String!\n  $secondaryStoryPackageArticlesQueueName: String!\n  $seriesWidgetArticlesQueueName: String!\n  $topStoriesQueueName: String!\n) {\n  topStories: queue(filter: {name: $topStoriesQueueName}) {\n    items(first: 18) {\n      edges {\n        ...heroThreeArticlesQueueItemsEdge\n        ...topStoriesQueueItemsEdge\n        node {\n          __typename\n          ...heroArticleArticle\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  morningStudioQueue: queue(filter: {name: $morningStudioQueueName}) {\n    ...hooksPickMorningStudioArticle\n    id\n  }\n  ...latestContentsQuery_2HMWA1\n  ...thingsToDoQueue\n  ...commentQueueQuery_pwKp9\n  ...chinaFutureTechStoryPackageQuery_4sW4gC\n  ...secondaryStoryPackageQuery_1swAuP\n  ...storyPackageQuery_1ZDJci\n  ...seriesWidgetQuery_iI4uX\n  ...spotlightQuery_Mf8QP\n  ...focusArticleHomeFocusArticleQuery_4COOKT\n  ...superSplashQuery_3oF9in\n  ...plusWidgetQuery_1YyBVf\n  ...chinaScienceDiscoveryWidgetQuery\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 5) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  storyPackageArticles: queue(filter: {name: $storyPackageArticlesQueueName}) {\n    items(first: 3) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  spotlightQueue: queue(filter: {name: $spotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  secondaryStoryPackageArticles: queue(filter: {name: $secondaryStoryPackageArticlesQueueName}) {\n    items(first: 4) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment aiArticleListSponsoredArticle on Article {\n  entityId\n  urlAlias\n  ...homeSecondaryContentItemContent\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment chinaFutureTechStoryPackageQuery_4sW4gC on Query {\n  section(filter: {entityId: $chinaFutureTechSectionEntityId}) {\n    name\n    ...entityLink\n    ...followButtonBase\n    ...sectionTermLogoSection\n    subSections {\n      settings\n      items {\n        edges {\n          ...entityOnelineMenuQueueItemsEdge\n        }\n      }\n      id\n    }\n    __typename\n    id\n  }\n  chinaFutureTechStoryPackageArticles: queue(filter: {name: $chinaFutureTechStoryPackageArticlesQueueName}) {\n    settings\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...topStoriesBlockQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment chinaScienceDiscoveryWidgetQuery on Query {\n  chinaScienceSection: section(filter: {entityId: \"328475\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment commentContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2RX0zR\n  ... on Video {\n    headline\n    duration\n    image(filter: {type: MAIN_IMAGE}) {\n      alt\n      style(filter: {style: \"1200x800\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment commentQueueQuery_pwKp9 on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    ...followButtonBase\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  harryContents: contents(contentTypes: [GALLERY], first: 1, filter: {sectionIds: $commentHarrySectionIds}, articleExcludeInput: {paywallTypeIds: $scmpPlusPaywallTypeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        __isContent: __typename\n        entityId\n        ...harryContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAgendaContentTopic on Topic {\n  newsAgenda {\n    secondaryDescription\n  }\n  description {\n    text\n  }\n  updatedDate\n  name\n  ...hooksNewsAgendaTopic\n}\n\nfragment contentAuthorImageContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    entityUuid\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent_2m5Gjt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3kXIcC on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size640x360: style(filter: {style: \"wide_landscape_640_360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3nLLMQ on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size660w: style(filter: {style: \"660w\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3ndUvy on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4isNar on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentMostPopularTagContent on Article {\n  entityId\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sections {\n    value {\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      name\n      id\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityOnelineMenuQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment focusArticleHomeFocusArticleQuery_4COOKT on Query {\n  focus: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ...homeFocusContentItemContent\n          ...helpersGetArticleTitleArticle\n          ...helpersGetPodcastTitlePodcast\n          ...helpersGetVideoTitleVideo\n          ...helpersCheckIsLiveArticle\n          ...helpersGetArticleLogoArticle\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment harryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3V3HsH\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on Section {\n  name\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleLogoArticle on Article {\n  sections {\n    value {\n      entityId\n      name\n      urlAlias\n      image(filter: {type: TERM_LOGO}) {\n        style(filter: {style: \"100x100\"}) {\n          url\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleTitleArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetPodcastTitlePodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetVideoTitleVideo on Video {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment heroArticleArticle on Article {\n  ...homeHeroArticleContentItemContent\n  entityId\n  moreOnThisArticles {\n    entityId\n    id\n  }\n}\n\nfragment heroThreeArticlesQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment homeFocusContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ... on Video {\n    duration\n  }\n  ...hooksContentItemProvidersContent_Q7hCx\n}\n\nfragment homeHeroArticleContentItemContent on Article {\n  entityId\n  urlAlias\n  moreOnThisArticles {\n    entityId\n    urlAlias\n    ...contentHeadlineContent\n    ...entityLink\n    id\n  }\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...contentTopicLinkContent\n  ...entityLink\n  ...hooksContentItemProvidersContent_1idf7Y\n}\n\nfragment homeLatestContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_22ZBVY\n  ... on Video {\n    duration\n  }\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1Bq5E1\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2vZosu\n}\n\nfragment homeStoryPackageLeadContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_17LfcA\n}\n\nfragment homeStoryPackageTailContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_101wKc\n}\n\nfragment homeSuperSplashLargePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_13AVp9\n}\n\nfragment homeSuperSplashLivePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_13AVp9\n}\n\nfragment homeSuperSplashLiveSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  ...entityLink\n  ...hooksContentItemProvidersContent_101wKc\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_101wKc on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_13AVp9 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2m5Gjt\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSubHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_17LfcA on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_4isNar\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1Bq5E1 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2m5Gjt\n  ...contentMostPopularTagContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1idf7Y on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2m5Gjt\n  ...contentMostPopularTagContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_22ZBVY on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2m5Gjt\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2Mm1vQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3ndUvy\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2RX0zR on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2vZosu on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2m5Gjt\n  ...contentMostPopularTagContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3V3HsH on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3nLLMQ\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Q7hCx on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3kXIcC\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksHomeStoryPackageTopicQueue on Queue {\n  refTerms {\n    __typename\n    ... on Newsletter {\n      name\n      latestArticleLink\n      __typename\n    }\n    ... on Section {\n      name\n      ...entityLink\n      ...followButtonBase\n      ...sectionTermLogoSection\n      __typename\n    }\n    ... on Topic {\n      name\n      ...entityLink\n      ...followButtonBase\n      ...topicTermLogoTopic\n      __typename\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  settings\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksNewsAgendaTopic on Topic {\n  newsAgenda {\n    startDate\n    endDate\n    time\n    newsAgendaOptions\n  }\n}\n\nfragment hooksPickMorningStudioArticle on Queue {\n  items(first: 9) {\n    edges {\n      node {\n        __typename\n        ...aiArticleListSponsoredArticle\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ...topStoriesQueueItemsEdge\n    }\n  }\n}\n\nfragment hooksPlusArticleLinkHandlerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  id\n  entityId\n  urlAlias\n}\n\nfragment hooksPlusWidgetConfigQuery on Query {\n  appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment itemAgendaItemTopic on Topic {\n  urlAlias\n  newsAgenda {\n    startDate\n  }\n  entityId\n  name\n  ...contentAgendaContentTopic\n  ...hooksNewsAgendaTopic\n}\n\nfragment latestContentsQuery_2HMWA1 on Query {\n  contents(contentTypes: [ARTICLE, GALLERY, VIDEO], first: 6, exclude: {sectionIds: $latestExcludeSectionIds}, articleExcludeInput: {articleTypeIds: $latestExcludeArticleTypes, paywallTypeIds: $scmpPlusPaywallTypeIds}, articleFilterInput: {sponsorTypes: [NONE]}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        entityId\n        ...homeLatestContentItemContent\n        id\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetQueue on Queue {\n  items(first: 6) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          entityId\n          ...homeSecondaryContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetSection on Section {\n  urlAlias\n  name\n  entityId\n  parentSection\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusWidgetDailyPulseQuery_3abQBm on Query {\n  dailyPulseQuery: articles(filter: {typeIds: [$dailyPulseTypeUuId]}, first: 1, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        urlAlias\n        ...entityLink\n        ...contentHeadlineContent\n        ...hooksArticleDateUtilsContent\n        ...hooksPlusArticleLinkHandlerArticle\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetHasAccessQuery_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment plusWidgetHighlight on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersGetArticleTypeArticle\n  ...hooksContentItemProvidersContent_2Mm1vQ\n  ...plusArticleTypeTitleContent\n}\n\nfragment plusWidgetHighlightsQuery_3iQMXB on Query {\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    items(first: 2) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...plusWidgetHighlight\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment plusWidgetNewsAgendaQuery_3kWRW2 on Query {\n  topics(first: 5, applicationId: $applicationId, filter: {types: $plusNewsAgendaTypes, newsAgendaDateRange: {startDate: $plusNewsAgendaStartDate, endDate: $plusNewsAgendaEndDate}, newsAgendaOptions: [\"key_event\"]}, orderBy: {field: NEWS_AGENDA_START_DATE, direction: ASC}) {\n    edges {\n      node {\n        ...itemAgendaItemTopic\n        ...hooksNewsAgendaTopic\n        newsAgenda {\n          newsAgendaOptions\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetQuery_1YyBVf on Query {\n  ...plusWidgetWithoutAccess_1YyBVf\n  ...plusWidgetHasAccessQuery_1YyBVf\n  ...hooksPlusWidgetConfigQuery\n}\n\nfragment plusWidgetWithoutAccess_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment secondaryStoryPackageQuery_1swAuP on Query {\n  secondaryStoryPackageArticles: queue(filter: {name: $secondaryStoryPackageArticlesQueueName}) {\n    ...hooksHomeStoryPackageTopicQueue\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...topStoriesBlockQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment sectionTermLogoSection on Section {\n  name\n  sectionLogo: image(filter: {type: TERM_LOGO}) {\n    style(filter: {style: \"100x100\"}) {\n      url\n    }\n  }\n}\n\nfragment seriesWidgetQuery_iI4uX on Query {\n  seriesWidgetArticles: queue(filter: {name: $seriesWidgetArticlesQueueName}) {\n    items {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            seriesShortLabel\n            ...seriesWidgetTabContentArticle\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment seriesWidgetTabContentArticle on Article {\n  seriesShortLabel\n  entityId\n  urlAlias\n  ...entityLink\n  series {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      urlAlias\n      publishedDate\n      ...entityLink\n      ...contentCoverImageContent_34Njms\n      ...helpersCheckIsPlusArticle\n      ...helpersCheckHasLiveTagArticle\n      ...helpersUseContentSponsorContent\n      ...hooksContentItemProvidersContent_2gnGW2\n      ...homeSecondaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment spotlightQuery_Mf8QP on Query {\n  spotlightQueue: queue(filter: {name: $spotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...topStoriesBlockQueueItemsEdge\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment storyPackageQuery_1ZDJci on Query {\n  storyPackageArticles: queue(filter: {name: $storyPackageArticlesQueueName}) {\n    ...hooksHomeStoryPackageTopicQueue\n    items(first: 3) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...entityLink\n            ...homeStoryPackageLeadContentItemContent\n            ...homeStoryPackageTailContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment superSplashLargeLiveWidget on LiveWidget {\n  label\n  description\n  relatedArticles {\n    ...homeSuperSplashLargePrimaryContentItemContent\n    ...homeSuperSplashLiveSecondaryContentItemContent\n    id\n  }\n}\n\nfragment superSplashLiveLiveWidget on LiveWidget {\n  label\n  relatedArticles {\n    entityUuid\n    urlAlias\n    ...homeSuperSplashLivePrimaryContentItemContent\n    ...homeSuperSplashLiveSecondaryContentItemContent\n    id\n  }\n}\n\nfragment superSplashQuery_3oF9in on Query {\n  liveWidget(filter: {edition: $liveWidgetEditionEnumValue}, orderBy: {direction: DESC, field: UPDATED_DATE}) {\n    style\n    ...superSplashLiveLiveWidget\n    ...superSplashLargeLiveWidget\n    id\n  }\n}\n\nfragment thingsToDoQueue on Query {\n  thingToDoQueue: queue(filter: {name: \"homepage_service_journalism_hk\"}) {\n    settings\n    items(first: 3) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment topStoriesBlockQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...topStoriesItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topStoriesQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...topStoriesBlockQueueItemsEdge\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment topicTermLogoTopic on Topic {\n  name\n  image(type: TERM_LOGO) {\n    style(filter: {style: \"100x100\"}) {\n      url\n    }\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a017106cd8b874c328e45c7d8f5b2fb";

export default node;
